import {Component, inject, OnInit} from '@angular/core';
import {Title} from "@angular/platform-browser";
import {confirmSignIn, fetchAuthSession, getCurrentUser, SignInOutput, resetPassword, signIn} from "aws-amplify/auth";
import {NavBarComponent} from "../../nav-bar/nav-bar.component";
import {CognitoService} from "../../cognito.service";
import {ManagementService} from "../../services/management.service";
import {AuthService} from "../../auth.service";
import {Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {LoginShareDataService} from "../../services/login-share-data.service";
import {MatDialog} from "@angular/material/dialog";
import {ViewPrivacyDialogComponent} from "../../dialogs/view-privacy-dialog/view-privacy-dialog.component";
import {CommunicationService} from "../../services/communication.service";
import {CommunicationTerms} from "../../models/communication-terms";
import {Term} from "../../models/communication-terms";
import {User} from "../../models/user";
import { Auth, signInAnonymously } from '@angular/fire/auth';
import { environment } from "src/environments/environment";
import { forkJoin } from 'rxjs';
;
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  needsNewPassword: boolean = false;
  shouldSendCode: boolean = false;
  showTempPassError: boolean = false;
  userRefreshed: boolean = false;
  forgotPasswordIssue: boolean = false;
  private fireAuth = inject(Auth);

  welcomeTitel: string = '';
  email: string = '';
  errorMessage: string = '';

  public environment = environment;

//   constructor(
//       public projectTitle: Title,
//       private nav: NavBarComponent,
//       private cognitoService: CognitoService,
//       private managementService: ManagementService,
//       private auth: AuthService,
//       private formBuilder: FormBuilder,
//       private router: Router,
//       private loginSharedDataService: LoginShareDataService,
//       private dialog: MatDialog,
//       private communicationService: CommunicationService
//   ) {
//     this.loginForm = formBuilder.group({
//       email: [null, [Validators.required, Validators.email]],
//       password: [null, Validators.required]
//     });
//   }

//   async ngOnInit() {
//    if(!this.needsNewPassword) {
//       this.errorMessage = '';
//       this.loginForm.markAllAsTouched();

//       const loggedIn = await this.auth.isLoggedIn();

//       if(loggedIn) {
//         await this.auth.logout();
//       }

//       if(this.loginForm.valid) {
//         this.nav.toggleLoading(true);
//         try {
//           const res = await signIn({
//             username: this.loginForm.value.email.toLowerCase(),
//             password: this.loginForm.value.password
//           });
//           await this.handleSignInNextSteps(res);
//         } catch (error) {
//             this.nav.toggleLoading(false);
//           console.error(error)
//           this.errorMessage = error?.message;
//             // if(error?.message.includes("Temporary password has expired")) {
//             //     this.showTempPassError = true;
//             // } else {
//             //     console.error(error)
//             //     this.errorMessage = error?.message;
//             // }
//         }

//       }
//     }
//   }

//   async handleSignInNextSteps(output: SignInOutput) {
//     const { nextStep } = output;

//     switch (nextStep.signInStep) {
//       case "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED":
//         this.nav.toggleLoading(false);
//         const email = this.loginForm.value.email.toLowerCase();

//         this.showPassword = false;
//         this.showConfirmPassword = false;

//         this.loginForm = this.formBuilder.group({
//           email: [{value: email, disabled: true}, [Validators.required, Validators.email]],
//           password: [null, [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=\S+$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).+$/)]],
//           confirmPassword: [null, Validators.required]
//         });
//         this.needsNewPassword = true;
//         break;

//       case "CONFIRM_SIGN_UP":
//         this.nav.toggleLoading(false);
//         this.errorMessage = "Please verify your email."
//         break;

//       case "DONE":
//         await this.isAuthenticated();
//         break;

//       default:
//         this.nav.toggleLoading(false);
//         break;
//     }
//   }

//   async createNewPassword() {
//     this.errorMessage = '';
//     this.loginForm.markAllAsTouched();

//     if(this.loginForm.valid) {
//       if(this.loginForm.value.password === this.loginForm.value.confirmPassword) {
//         this.nav.toggleLoading(true);
//         await confirmSignIn({
//           challengeResponse: this.loginForm.value.password
//         }).then(() => {
//           this.isAuthenticated();
//         }).catch((e) => {
//           this.nav.toggleLoading(false);
//           this.errorMessage = e?.message;
//         });
//       } else {
//         this.errorMessage = 'Passwords need to be the same.';
//         this.nav.toggleLoading(false);
//       }
//     }
//   }

//   async isAuthenticated() {
//     const authUser = await getCurrentUser();

//     if (!sessionStorage.getItem('user') && authUser) {

//       signInAnonymously(this.fireAuth).catch(function (error) {
//             const errorCode = error.code;
//             const errorMessage = error.message;
//           });

//       this.managementService.getUserRequest(authUser.signInDetails.loginId).subscribe((user) => {
//         this.auth.userSubject.next(user);
//         let jsonUser = JSON.stringify(user);
//         sessionStorage.setItem("user", jsonUser);
//         this.continueWithAuth(user);
//       });
//     }
//   }

//   checkUserTerms(user: User) {
//     this.communicationService.getCommunicationTerms().subscribe({
//       next: (res: CommunicationTerms) => {
//         if(!res.confirmed) {

//         } else {
//           sessionStorage.setItem('privacyConfirmed', 'true');

//         }
//       }
//     })
//   }

//   async continueWithAuth(user: User) {
//     setTimeout(() => {
//       this.managementService.getUserTenants(user.id).subscribe((tenants) => {
//         tenants.sort((a, b) => a.name.localeCompare(b.name));
//         this.auth.tenantsSubject.next(tenants);
//         let jsonTenants = JSON.stringify(tenants);
//         sessionStorage.setItem("tenants", jsonTenants);
//       })
//     }, 1000);



//     this.managementService.getUserRoles(user.id).subscribe(roles => {
//       this.auth.rolesSubject.next(roles);
//       let jsonRoles = JSON.stringify(roles);
//       sessionStorage.setItem("roles", jsonRoles);
//       if(localStorage.getItem('firstTimeLogin')) {
//         this.router.navigate([localStorage.getItem('firstTimeLogin')]);
//       } else {
//         this.router.navigate([user.landingPage]);
//       }
//     });
//   }

//   toggleForgotPassword() {
//     this.shouldSendCode = !this.shouldSendCode;
//     const email = this.loginForm.get('email').value;
//     this.forgotPasswordIssue = false;

//     if(this.shouldSendCode) {
//       this.loginForm = this.formBuilder.group({
//         email: [email, [Validators.required, Validators.email]]
//       });
//     } else {
//       this.loginForm = this.formBuilder.group({
//         email: [email, [Validators.required, Validators.email]],
//         password: [null, Validators.required]
//       });
//     }
//   }

//   async sendCode() {
//     if(this.shouldSendCode) {
//       this.loginForm.markAllAsTouched();

//       if(this.loginForm.valid) {
//         this.nav.toggleLoading(true);

//         this.managementService.checkUserForResetPassword(this.loginForm.value.email.toLowerCase()).subscribe({
//           next: async (res) => {
//             this.nav.toggleLoading(false);
//             if (res.status === 200) {
//               try {
//                 const {nextStep} = await resetPassword({
//                   username: this.loginForm.value.email.toLowerCase()
//                 })

//                 if (nextStep.resetPasswordStep === 'CONFIRM_RESET_PASSWORD_WITH_CODE') {
//                   this.loginSharedDataService.setEmailData(this.loginForm.get('email').value);
//                   this.router.navigateByUrl(`/forgot-password/${this.loginForm.value.email}`);
//                 }
//               } catch (error) {
//                 this.errorMessage = error?.message;
//               }
//             } else {
//               this.email = this.loginForm.value.email.toLowerCase();
//               this.userRefreshed = true;
//             }
//           },
//           error: (err) => {
//             this.nav.toggleLoading(false);
//             this.forgotPasswordIssue = true;
//           }
//         });

//       }
//     }
//   }

//   sendTempPassword() {
//     this.loginForm.get('email').markAsTouched();
//     if(this.loginForm.get('email').valid) {
//       this.nav.toggleLoading(true);
//       this.communicationService.sendTempPassword(this.loginForm.value.email.toLowerCase()).subscribe({
//         next: (res) => {
//           this.nav.toggleLoading(false);
//           this.showTempPassError = false;
//           this.errorMessage = "A new Temporary Password has been sent to your email. Please check your inbox."
//         },
//         error: (error) => {
//           this.nav.toggleLoading(false);
//           this.showTempPassError = false;
//           this.errorMessage = "A new Temporary Password has been sent to your email. Please check your inbox."
//         }
//       });
//     }
//   }
  
    
//   getWelcometitle(): string{
//     this.welcomeTitel = environment.theme.welcomeTitle;
//     return this.welcomeTitel;
//   }
// }
 constructor(
      public projectTitle: Title,
      private nav: NavBarComponent,
      private cognitoService: CognitoService,
      private managementService: ManagementService,
      private auth: AuthService,
      private formBuilder: FormBuilder,
      private router: Router,
      private loginSharedDataService: LoginShareDataService,
      private dialog: MatDialog,
      private communicationService: CommunicationService,
  ) {
    this.loginForm = formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, Validators.required]
    });
  }

  async ngOnInit() {
    sessionStorage.clear();
    // if(sessionStorage.getItem('user') && !sessionStorage.getItem('privacyConfirmed')) {
    //   const user = JSON.parse(sessionStorage.getItem('user'));
    //   console.log(user)
    //   this.checkUserTerms(user);
    // }
  }

  async login() {
    if(!this.needsNewPassword) {
      this.errorMessage = '';
      this.loginForm.markAllAsTouched();

      const loggedIn = await this.auth.isLoggedIn();

      if(loggedIn) {
        await this.auth.logout();
      }

      if(this.loginForm.valid) {
        this.nav.toggleLoading(true);
        try {
          const res = await signIn({
            username: this.loginForm.value.email.toLowerCase(),
            password: this.loginForm.value.password
          });
          await this.handleSignInNextSteps(res);
        } catch (error) {
            this.nav.toggleLoading(false);
          console.error(error)
          this.errorMessage = error?.message;
            // if(error?.message.includes("Temporary password has expired")) {
            //     this.showTempPassError = true;
            // } else {
            //     console.error(error)
            //     this.errorMessage = error?.message;
            // }
        }

      }
    }
  }

  async handleSignInNextSteps(output: SignInOutput) {
    const { nextStep } = output;

    switch (nextStep.signInStep) {
      case "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED":
        this.nav.toggleLoading(false);
        const email = this.loginForm.value.email.toLowerCase();

        this.showPassword = false;
        this.showConfirmPassword = false;

        this.loginForm = this.formBuilder.group({
          email: [{value: email, disabled: true}, [Validators.required, Validators.email]],
          password: [null, [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=\S+$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).+$/)]],
          confirmPassword: [null, Validators.required]
        });
        this.needsNewPassword = true;
        break;

      case "CONFIRM_SIGN_UP":
        this.nav.toggleLoading(false);
        this.errorMessage = "Please verify your email."
        break;

      case "DONE":
        await this.isAuthenticated();
        break;

      default:
        this.nav.toggleLoading(false);
        break;
    }
  }

  async createNewPassword() {
    this.errorMessage = '';
    this.loginForm.markAllAsTouched();

    if(this.loginForm.valid) {
      if(this.loginForm.value.password === this.loginForm.value.confirmPassword) {
        this.nav.toggleLoading(true);
        await confirmSignIn({
          challengeResponse: this.loginForm.value.password
        }).then(() => {
          this.isAuthenticated();
        }).catch((e) => {
          this.nav.toggleLoading(false);
          this.errorMessage = e?.message;
        });
      } else {
        this.errorMessage = 'Passwords need to be the same.';
        this.nav.toggleLoading(false);
      }
    }
  }

  async isAuthenticated() {
    const authUser = await getCurrentUser();

    if (!sessionStorage.getItem('user') && authUser) {

      signInAnonymously(this.fireAuth).catch(function (error) {
            const errorCode = error.code;
            const errorMessage = error.message;
          });

      this.managementService.getUserRequest(authUser.signInDetails.loginId).subscribe((user) => {
        this.auth.userSubject.next(user);
        let jsonUser = JSON.stringify(user);
        sessionStorage.setItem("user", jsonUser);
        this.continueWithAuth(user);
      });
    }
  }

  checkUserTerms(user: User) {
    this.communicationService.getCommunicationTerms().subscribe({
      next: (res: CommunicationTerms) => {
        if(!res.confirmed) {

        } else {
          sessionStorage.setItem('privacyConfirmed', 'true');

        }
      }
    })
  }

  async continueWithAuth(user: User) {
    forkJoin({
      tenants: this.managementService.getUserTenants(user.id),
      roles: this.managementService.getUserRoles(user.id)
    }).subscribe(({ tenants, roles }) => {
      tenants.sort((a, b) => a.name.localeCompare(b.name));
      this.auth.tenantsSubject.next(tenants);
      sessionStorage.setItem("tenants", JSON.stringify(tenants));

      const home = tenants.find(t => t.isHomeTenant);
      if (home) {
        sessionStorage.setItem("selectedTenant", home.id.toString());
      }

      this.auth.rolesSubject.next(roles);
      sessionStorage.setItem("roles", JSON.stringify(roles));

      if (localStorage.getItem('firstTimeLogin')) {
        this.router.navigate([localStorage.getItem('firstTimeLogin')]);
      } else {
        this.router.navigate([user.landingPage]);
      }
    });
  }

  toggleForgotPassword() {
    this.shouldSendCode = !this.shouldSendCode;
    const email = this.loginForm.get('email').value;
    this.forgotPasswordIssue = false;

    if(this.shouldSendCode) {
      this.loginForm = this.formBuilder.group({
        email: [email, [Validators.required, Validators.email]]
      });
    } else {
      this.loginForm = this.formBuilder.group({
        email: [email, [Validators.required, Validators.email]],
        password: [null, Validators.required]
      });
    }
  }

  async sendCode() {
    if(this.shouldSendCode) {
      this.loginForm.markAllAsTouched();

      if(this.loginForm.valid) {
        this.nav.toggleLoading(true);

        this.managementService.checkUserForResetPassword(this.loginForm.value.email.toLowerCase()).subscribe({
          next: async (res) => {
            this.nav.toggleLoading(false);
            if (res.status === 200) {
              try {
                const {nextStep} = await resetPassword({
                  username: this.loginForm.value.email.toLowerCase()
                })

                if (nextStep.resetPasswordStep === 'CONFIRM_RESET_PASSWORD_WITH_CODE') {
                  this.loginSharedDataService.setEmailData(this.loginForm.get('email').value);
                  this.router.navigateByUrl(`/forgot-password/${this.loginForm.value.email}`);
                }
              } catch (error) {
                this.errorMessage = error?.message;
              }
            } else {
              this.email = this.loginForm.value.email.toLowerCase();
              this.userRefreshed = true;
            }
          },
          error: (err) => {
            this.nav.toggleLoading(false);
            this.forgotPasswordIssue = true;
          }
        });

      }
    }
  }

  sendTempPassword() {
    this.loginForm.get('email').markAsTouched();
    if(this.loginForm.get('email').valid) {
      this.nav.toggleLoading(true);
      this.communicationService.sendTempPassword(this.loginForm.value.email.toLowerCase()).subscribe({
        next: (res) => {
          this.nav.toggleLoading(false);
          this.showTempPassError = false;
          this.errorMessage = "A new Temporary Password has been sent to your email. Please check your inbox."
        },
        error: (error) => {
          this.nav.toggleLoading(false);
          this.showTempPassError = false;
          this.errorMessage = "A new Temporary Password has been sent to your email. Please check your inbox."
        }
      });
    }
  }
    getWelcometitle(): string{
    this.welcomeTitel = environment.theme.welcomeTitle;
    return this.welcomeTitel;
  }
}